var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headerElem'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('FooterElem'),(_vm.style)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.style)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }